<!--
 * @Description: 
 * @Author: wjx
 * @Github: 
 * @LastEditors: wjx
 * @Date: 2019-01-15 19:30:58
 * @LastEditTime: 2019-03-08 09:54:42
 -->

<template>
  <ul class="list_box">
    <li
      class=" vux-1px-b"
      v-for="(item, index) in list"
      @click="jump(item)"
      :key="index"
    >
      <div class="bingli-item-top">
        <div class="div1">
          <img :src="item.head_photo || item.headPhoto" alt="" />
          <div class="div2">
            <p class="p1">
              <span>{{ item.real_name || item.userName }}</span>
              <span class="p1_span1" v-if="item.dataType == 'case'">
                {{ item.duty }}
              </span>
            </p>
            <p class="p2" v-if="item.dataType == 'case'">{{ item.hospital }}</p>
            <p class="p2" v-else>{{ item.createTime | transDate }}</p>
          </div>
        </div>

        <p class="p3">{{ numberRender(item) }}</p>
      </div>
      <div class="bingli-item-bottom">
        <div :class="[item.backPic ? 'bingli-item-hasimg' : '']">
          <p class="hidden-text p4">{{ item.title }}</p>
          <p class="p5">{{ item.content }}</p>
        </div>
        <img v-if="item.backPic" :src="item.backPic" alt="" />
      </div>
    </li>
  </ul>
</template>
<script>
/*
 * props  @list  列表数据
 *        @bottomObj 右下 内容
 *        @needHighlight 是否需要关键字高亮
 *        @keys 关键字
 *        @path 转跳类型
 *
 * */
export default {
  name: '',
  props: {
    needHighlight: {
      type: Boolean,
      default: false
    },
    keys: {
      type: String,
      default: '特殊'
    },
    path: {
      default: 'headlineDetail'
    },

    list: {
      type: Array,
      default: function() {
        return [];
      }
    },
    ifShare: {
      // 是否为分享落地页
      type: Number,
      default: 2
    }
  },
  data() {
    return {};
  },
  methods: {
    numberRender(item) {
      let { commontNum, readNum, subNum } = item;
      if (commontNum > 20 && subNum > 10) {
        return `${readNum}位同行阅读`;
      } else if (commontNum > 20) {
        return `${commontNum}位同行讨论`;
      } else if (subNum > 10) {
        return `${subNum}位同行收藏`;
      } else {
        return `${readNum}位同行阅读`;
      }
    },
    seachFifter(content) {
      if (this.needHighlight) {
        let filtercontent = content.replace(/<|>/g, '');
        return filtercontent.replace(
          new RegExp(this.keys, 'g'),
          '<span class=\'colorRed\'>' + this.keys + '</span>'
        );
      } else {
        return content;
      }
    },
    goYsh() {
      window.location =
        'http://a.app.qq.com/o/simple.jsp?pkgname=com.yxvzb.app';
    },
    jump(item) {
      let itemType = 3;
      let query = {};
      if (item.dataType == 'case') {
        itemType = 2;
      } else if (item.dataType == 'note') {
        itemType = 8;
      }
      query.type = itemType;
      this.$route.query.shareFlag && Object.assign(query, { shareFlag: true });
      this.$router.push({
        name: this.path,
        params: {
          id: item.id
        },
        query
      });
    }
  },
  computed: {},
  components: {},
  mounted() {},
  filters: {
    heighLight: function(v) {
      return v + '<span>123</span>';
    }
  }
};
</script>
<style lang="less" scoped>
li {
  margin: 0.4rem 0.4rem 0; /* 30/75 */
  padding-bottom: 0.4rem;
}

.hidden-text {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.bingli-item-top {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  .div1 {
    display: flex;
    align-items: center;
  }
  img {
    width: 0.9067rem /* 68/75 */;
    height: 0.9067rem /* 68/75 */;
    border-radius: 50%;
    margin-right: 0.2667rem /* 20/75 */;
  }
  .div2 {
    .p1 {
      font-size: 0.4rem /* 30/75 */;
      color: #027cfa;
      span {
        margin-right: 0.2667rem /* 20/75 */;
      }
      .p1_span1 {
        color: #666666;
        font-size: 0.32rem;
      }
    }
    .p2 {
      width: 5.2rem;
      font-size: 0.2667rem /* 20/75 */;
      // height: .5rem;
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
      color: #666666;
    }
  }
  .p3 {
    width: 3rem;
    font-size: 0.2667rem /* 20/75 */;
    color: #666666;
    text-align: right;
  }
}

.bingli-item-bottom {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 0.32rem /* 24/75 */;
  div {
    width: 100%;
  }
  .bingli-item-hasimg {
    width: 6.2rem;
  }
  img {
    width: 1.7333rem /* 130/75 */;
    height: 1.7333rem /* 130/75 */;
  }
  p {
    line-height: 1.2;
  }
  .p4 {
    font-size: 0.4rem;
    color: #161616;
  }
  .p5 {
    font-size: 0.32rem /* 24/75 */;
    color: #666666;
    margin-top: 0.2667rem /* 20/75 */;
    overflow: hidden;
    text-overflow: ellipsis;
    -webkit-box-orient: vertical;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    line-height: 0.44rem /* 33/75 */;
  }
}
</style>
